<template>
  <VideoPlayer :src="optimizedSrc" />
</template>
<script setup lang="ts">
import { useOptimizedVideoUrl } from '@/wabunka-src/common/composables/general/useOptimizedVideoUrl';
import type { OptimizeVideoOptions } from '@/wabunka-src/common/utils/video/videoOptimizer';

interface Props {
  /** CMS の生 動画 URL（最適化はこのコンポーネントが行うため、呼び出し側は生 URL を渡す） */
  videoUrl: string;
  /** Cloudflare Media Transformations オプション（width / height / fit / audio） */
  optimizedVideoOptions?: OptimizeVideoOptions;
  /** VideoPlayer の遅延ロードに失敗したときのコールバック（スケルトン解除等に使う） */
  onLoadError?: () => void;
}
const props = withDefaults(defineProps<Props>(), {
  optimizedVideoOptions: () => ({}),
  onLoadError: undefined,
});

// CMS の生 URL を Cloudflare Media Transformations(mode=video) 経由にして再エンコード＆リサイズし帯域を削減する。
const getOptimizedVideoUrl = useOptimizedVideoUrl();
const optimizedSrc = computed(() => getOptimizedVideoUrl(props.videoUrl, props.optimizedVideoOptions));

// Video.js v10 (@videojs/html) は重いためクライアントで遅延ロードする。
// 読込失敗時は onLoadError を通知してから fail（呼び出し側でスケルトン解除等を行う）。
const VideoPlayer = defineAsyncComponent({
  loader: () => import('../VideoPlayer/VideoPlayer.vue'),
  onError(_error, _retry, fail) {
    props.onLoadError?.();
    fail();
  },
});
</script>
